import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '39aa4fe6-2777-4d49-b9ad-6df49af3231d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Christmas_mission_board',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: '3227a367-3f86-47e7-b330-ba54ac5b2db3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -10,
      y: -222,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_timer',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: '02444825-d5d9-4a4a-8760-3084104d3628',
      type: 'Sprite',
      name: 'eventBG',
      nameSpace: '',
      className: '',
      x: 0,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'xmas_2021_clearCardAny',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: 'd48151bd-fad1-4355-8001-e4f1263a2262',
      type: 'Sprite',
      name: 'shadowSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_shadow',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: 'af8c6c2c-ac3d-4824-bb99-78121773df93',
      type: 'Sprite',
      name: 'collectButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 312,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: 'e31885f6-90ae-4238-81d3-659d2f68404d',
      type: 'Graphics',
      name: 'overlay',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      bake: false,
      commands: [
        {
          id: '8bdb4332-945e-47be-8a12-6d344807af20',
          type: 'beginFill',
          color: 0,
          alpha: 0.7
        },
        {
          id: '43e93b1f-eb45-45db-a272-4a5d2f98022b',
          type: 'drawRect',
          x: -2000,
          y: -2000,
          width: 4000,
          height: 4000
        }
      ],
      data: ''
    },
    {
      id: 'cd53a7e6-d895-4ef0-bbb0-092b84793246',
      type: 'Sprite',
      name: 'giftDetailsSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: -127,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_reward_preview',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: 'bf7ff353-29f2-4a02-abb0-1fb6a305d402',
      type: 'Text',
      name: 'timeText',
      nameSpace: '',
      className: '',
      x: 19,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '',
      localize: false,
      maxWidth: 100,
      maxHeight: 34,
      maxFontSize: 27,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFFFFF',
        stroke: '#692012',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3227a367-3f86-47e7-b330-ba54ac5b2db3',
      data: ''
    },
    {
      id: 'e5535388-1a25-412b-a71b-58f606fa8230',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 86,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_panel_bg',
      parent: '02444825-d5d9-4a4a-8760-3084104d3628',
      data: ''
    },
    {
      id: '6d759bcd-e960-4feb-a50e-39e3fb9862b5',
      type: 'Sprite',
      name: 'lockSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_lock',
      parent: 'd48151bd-fad1-4355-8001-e4f1263a2262',
      data: ''
    },
    {
      id: 'b27421e5-6fd5-462c-bfc7-79082064dade',
      type: 'Sprite',
      name: 'bigCheckSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_check',
      parent: 'd48151bd-fad1-4355-8001-e4f1263a2262',
      data: ''
    },
    {
      id: '0b573121-cd3e-49b3-a5ab-b92c639b1b80',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Collect',
      localize: true,
      maxWidth: 198,
      maxHeight: 85,
      maxFontSize: 55,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#074829',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'af8c6c2c-ac3d-4824-bb99-78121773df93',
      data: ''
    },
    {
      id: '24e16251-32d5-4728-9677-316f680c2d05',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 43,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'ClickToContinue',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e31885f6-90ae-4238-81d3-659d2f68404d',
      data: ''
    },
    {
      id: '2befddf7-4773-427f-9d18-cde495aba28c',
      type: 'Sprite',
      name: 'itemSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: -47,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: 'cd53a7e6-d895-4ef0-bbb0-092b84793246',
      data: ''
    },
    {
      id: 'cdbfa411-dde0-4739-a551-8fb1648c4725',
      type: 'Text',
      name: 'rewardText',
      nameSpace: '',
      className: '',
      x: 21,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1000 coins',
      localize: false,
      maxWidth: 154,
      maxHeight: 36,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ba372b',
        stroke: '#933019',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'cd53a7e6-d895-4ef0-bbb0-092b84793246',
      data: ''
    },
    {
      id: 'ea431fa3-2b3a-44ba-96cd-1078c6c59499',
      type: 'Sprite',
      name: 'rewardSprite',
      nameSpace: '',
      className: '',
      x: -72,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_coin',
      parent: 'cd53a7e6-d895-4ef0-bbb0-092b84793246',
      data: ''
    },
    {
      id: '4461311d-eca8-490c-8050-5e06231e181a',
      type: 'Text',
      name: 'missionText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -102,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Collect 10 stars',
      localize: false,
      maxWidth: 230,
      maxHeight: 35,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#311119',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e5535388-1a25-412b-a71b-58f606fa8230',
      data: ''
    },
    {
      id: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
      type: 'Sprite',
      name: 'progressBar',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_bar_back',
      parent: 'e5535388-1a25-412b-a71b-58f606fa8230',
      data: ''
    },
    {
      id: '811c67ab-a5e0-44c1-8478-e0b70e0f6e64',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 84,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_cell',
      parent: 'e5535388-1a25-412b-a71b-58f606fa8230',
      data: ''
    },
    {
      id: '51299b50-b9d8-4e3f-9898-5fa266746a86',
      type: 'Text',
      name: 'lockText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 105,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 54',
      localize: false,
      maxWidth: 210,
      maxHeight: 50,
      maxFontSize: 33,
      icons: [],
      style: {
        fontSize: 33,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFFFFF',
        stroke: 'black',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '6d759bcd-e960-4feb-a50e-39e3fb9862b5',
      data: ''
    },
    {
      id: '5661801f-4cb1-48f2-bf81-11b3c93dc6e0',
      type: 'NineSlicePlane',
      name: 'progressBarFill',
      nameSpace: '',
      className: '',
      x: 2,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 121,
        y: 20
      },
      width: 241,
      height: 40,
      leftWidth: 16,
      topHeight: 8,
      rightWidth: 16,
      bottomHeight: 8,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_bar_green',
      parent: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
      data: ''
    },
    {
      id: '2b7e8b88-1a68-4c87-943f-076091823d5b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 41,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_bar_below',
      parent: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
      data: ''
    },
    {
      id: '329ba0b9-30ee-4be2-808f-7cabd9cc9d84',
      type: 'Sprite',
      name: 'progressBarFrontSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_bar_front',
      parent: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
      data: ''
    },
    {
      id: 'a67e95fd-d6cb-4953-9a56-f38e635e055a',
      type: 'Sprite',
      name: 'checkSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_small_check',
      parent: '811c67ab-a5e0-44c1-8478-e0b70e0f6e64',
      data: ''
    },
    {
      id: '4de813c8-d1fc-48e0-b0f8-1e498fedb75d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_for_gift',
      parent: '5661801f-4cb1-48f2-bf81-11b3c93dc6e0',
      data: ''
    },
    {
      id: 'cb721cad-5d16-4051-b54e-6a69265024f6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 114,
      y: 5,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_for_gift',
      parent: '5661801f-4cb1-48f2-bf81-11b3c93dc6e0',
      data: ''
    },
    {
      id: '36d32368-95a0-4b35-b1b6-b3f969506fe7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 217,
      y: 5,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_for_gift',
      parent: '5661801f-4cb1-48f2-bf81-11b3c93dc6e0',
      data: ''
    },
    {
      id: '80393e63-9adc-4510-9fd5-e13c0991e981',
      type: 'Text',
      name: 'progressText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '23 / 100',
      localize: false,
      maxWidth: 139,
      maxHeight: 40,
      maxFontSize: 26,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#002424',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2b7e8b88-1a68-4c87-943f-076091823d5b',
      data: ''
    },
    {
      id: 'dad2330c-10a0-4741-801a-8ba02993d370',
      type: 'Text',
      name: 'giftText',
      nameSpace: '',
      className: 'giftTooltipText',
      x: 0,
      y: -58,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '20',
      localize: false,
      maxWidth: 43,
      maxHeight: 18,
      maxFontSize: 16,
      icons: [],
      style: {
        fontSize: 16,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#671e0a',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4de813c8-d1fc-48e0-b0f8-1e498fedb75d',
      data: ''
    },
    {
      id: '33739bd4-2516-476f-ad11-b07bdeaf0a15',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Christmas_mission_gift',
      parent: '4de813c8-d1fc-48e0-b0f8-1e498fedb75d',
      data: ''
    },
    {
      id: 'dd6750fb-d5d2-4b3f-8fae-dad53979ba28',
      type: 'Text',
      name: 'giftText',
      nameSpace: '',
      className: 'giftTooltipText',
      x: 0,
      y: -58,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '20',
      localize: false,
      maxWidth: 43,
      maxHeight: 18,
      maxFontSize: 16,
      icons: [],
      style: {
        fontSize: 16,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#671e0a',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'cb721cad-5d16-4051-b54e-6a69265024f6',
      data: ''
    },
    {
      id: 'f2e74f77-ab41-4528-a512-38f657fa2611',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Christmas_mission_gift',
      parent: 'cb721cad-5d16-4051-b54e-6a69265024f6',
      data: ''
    },
    {
      id: '7a96878b-1019-4421-af9e-8471f9fec33f',
      type: 'Text',
      name: 'giftText',
      nameSpace: '',
      className: 'giftTooltipText',
      x: 0,
      y: -58,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '20',
      localize: false,
      maxWidth: 43,
      maxHeight: 18,
      maxFontSize: 16,
      icons: [],
      style: {
        fontSize: 16,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#671e0a',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '36d32368-95a0-4b35-b1b6-b3f969506fe7',
      data: ''
    },
    {
      id: '457c1c0b-6547-4881-80a0-55e78b07b0f9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Christmas_mission_gift',
      parent: '36d32368-95a0-4b35-b1b6-b3f969506fe7',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class XMas2021QuestsSubLayout {
  static raw = raw;
  root: PIXI.Container
  timeText: PIXI.Text
  eventBG: PIXI.Sprite
  missionText: PIXI.Text
  progressBar: PIXI.Sprite
  progressBarFill: PIXI.NineSlicePlane
  giftText: PIXI.Text
  progressText: PIXI.Text
  progressBarFrontSprite: PIXI.Sprite
  checkSprite: PIXI.Sprite
  shadowSprite: PIXI.Sprite
  lockSprite: PIXI.Sprite
  lockText: PIXI.Text
  bigCheckSprite: PIXI.Sprite
  collectButton: PIXI.Sprite
  overlay: PIXI.Graphics
  giftDetailsSprite: PIXI.Sprite
  itemSprite: PIXI.Sprite
  rewardText: PIXI.Text
  rewardSprite: PIXI.Sprite
  giftTooltipText: (PIXI.Text)[]

  constructor() {
    populate(this, raw);
  }
}
